// auto-generated by Typewriter template _models.tst from PortCall.Pilots.EndPoints\Extensions\PilotsMorePageExtension.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { MorePage, MorePageData, MorePageOptions } from 'data/models/MorePage';

// PilotsMorePageData is the class that PilotsMorePage serializes to/from
export interface PilotsMorePageData {
    UserId : number;
	
    MorePage : MorePageData | null;
	
    CanManageSettingsAgencies : number[];
}

// PilotsMorePageOptions is the class which may be passed to the PilotsMorePage constructor to define optional initial data values
export interface PilotsMorePageOptions {
    UserId : number;
	
    MorePage? : MorePageOptions | null;
	
    CanManageSettingsAgencies? : number[];
}

export class PilotsMorePage {
    public UserId : DataSignal<number>;
	
    public MorePage : DataSignal<MorePage | null>;
	
    public CanManageSettingsAgencies : SDataArray<number>;

    constructor();
    constructor(data : PilotsMorePageOptions);
    constructor(data: PilotsMorePageOptions | null = null) {
        this.UserId = jsonableObservable(S.value<number>(data && data.UserId !== undefined ? data.UserId : 0));
	    
        this.MorePage = S.value<MorePage | null>(null);
	    
        this.CanManageSettingsAgencies = jsonableObservable(SArray<number>(data && data.CanManageSettingsAgencies !== undefined ? data.CanManageSettingsAgencies : []));
    }

    static key(obj : PilotsMorePage) {
        return obj.UserId();
    }
    
    static dataKey(obj : PilotsMorePageOptions) {
        return obj.UserId;
    }

    static update(obj : PilotsMorePage, data : PilotsMorePageOptions) {
        S.freeze(() => {
            if (data.UserId !== undefined) obj.UserId(data.UserId);
	        
	        
            if (data.CanManageSettingsAgencies !== undefined) obj.CanManageSettingsAgencies(data.CanManageSettingsAgencies);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/PilotsMorePage.ts